import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import { updateComponent } from '../../state/actions/componentsActions.js'
import { connect } from 'react-redux'
import MobileDetect from 'mobile-detect'
import { camelize } from '../../utils'
import Textbox from '../textbox'

import 'react-datepicker/dist/react-datepicker.css'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class Datepicker extends Component {
  constructor(props) {
    super(props)

    moment.locale('it')
    this.state = props.component.value
      ? {
          date: moment(
            props.component.value,
            props.component.field && !!props.component.field.format
              ? props.component.field.format.toUpperCase()
              : 'DD/MM/YYYY'
          )
        }
      : {}
  }

  // handleClick(e) {
  //   if (e.target.type === 'text') {
  //     const root = document.getElementById('root').childNodes[0]
  //     const datePicker = document.querySelectorAll(
  //       '[class^="react-datepicker__tether-element"]'
  //     )[0]
  //     if (!!datePicker) {
  //       root.appendChild(datePicker)
  //       datePicker.style.display = 'block'
  //     }
  //   }
  // }

  handleChange(date) {
    const { component, dispatch } = this.props
    dispatch(
      updateComponent(component.id, {
        value: date.format(
          component.field && !!component.field.format
            ? component.field.format.toUpperCase()
            : 'DD/MM/YYYY'
        )
      })
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.component) {
      this.setState({
        date: !!nextProps.component.value
          ? moment(
              nextProps.component.value,
              nextProps.component.field && !!nextProps.component.field.format
                ? nextProps.component.field.format.toUpperCase()
                : 'DD/MM/YYYY'
            )
          : undefined
      })
    }
  }

  validateRequired() {
    const { component } = this.props
    if (
      component.validations &&
      component.validations.isRequired &&
      !component.isDisabled
    ) {
      return true
    }
    return false
  }

  render() {
    const { component, widget } = this.props
    const md = new MobileDetect(window.navigator.userAgent)

    if (!this.globalStylesOverrides) {
      this.globalStylesOverrides = css(this.props.styles.globals)
    }

    if (!!md.mobile()) {
      return (
        <div
          {...css(
            this.props.styles.component,
            this.props.styles['component--bare']
          )}
        >
          <Textbox
            key={`${component.name}-text`}
            widget={widget}
            component={component}
            type={'text'}
          />
          <Textbox
            key={`${component.name}-date`}
            widget={widget}
            component={component}
            type={'date'}
          />
        </div>
      )
    } else {
      return (
        <div
          {...css(this.props.styles.component, 
            this.props.component.statusStyle === 'hidden'? this.props.styles['hide-datepicker']:'' )}
          // onClick={e => this.handleClick(e)}
        >
          <DatePicker
            dateFormat={
              component.field && !!component.field.format
                ? component.field.format.toUpperCase()
                : 'DD/MM/YYYY'
            }
            key={`${component.name}-date`}
            {...css(
              this.props.styles.input,
              component.status.indexOf('error') > -1 &&
                this.props.styles['input--invalid'],
              component.status.indexOf('loading') > -1 &&
                this.props.styles['input--blink']
            )}
            selected={this.state.date}
            disabled={
              !!component.isDisabled ||
              component.status.indexOf('readonly') > -1 ||
              widget.status.indexOf('readonly') > -1
            }
            onChange={date => this.handleChange(date)}
            showYearDropdown
            showMonthDropdown
            scrollableYearDropdown
            placeholderText={component.cleanName}
            name={component.id}
          />
          <span
            {...css(
              this.props.styles.label,
              this.state.value !== '' && this.props.styles['label--active']
            )}
          >
            {component.cleanName}
            {this.validateRequired() ? (
              <span {...css(this.props.styles['label--required'])}>
                &nbsp;*
              </span>
            ) : (
              ''
            )}
          </span>
          {!component.isDisabled ? (
            <small {...css(this.props.styles['error-msg'])}>
              {camelize(component.errorMessage[0], true, true)}
            </small>
          ) : (
            ''
          )}
        </div>
      )
    }
  }
}

Datepicker.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['text', 'date']),
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return { component: components[ownProps.component.id] }
}

export default connect(mapStateToProps)(withStyles(Styles)(Datepicker))



// WEBPACK FOOTER //
// ./components/datepicker/index.js